<div class="alumni-page">
  <app-header-style-seven></app-header-style-seven>

  <div class="custom-container">
    <section class="alumni-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Institutional Support</span>
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSubtitle }}</p>
        </div>

        <div class="hero-stats">
          <div class="stat-card" *ngFor="let stat of heroStats">
            <span class="stat-label">{{ stat.label }}</span>
            <strong>{{ stat.value }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="alumni-shell">
      <aside class="alumni-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Cell Menu</span>
          <h2>FMCET Development Cells</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="alumni-main">
        <section class="content-head-card">
          <span class="content-tag">Institutional Cells</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Fatima Michael College of Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="section-head" style="margin-top: 0;">
                <h3>Women Empowerment Cell Committee Members</h3>
                <p>
                  Committee members of the Women Empowerment Cell of FMCET.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name of the Members</th>
                      <th>Designation</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let member of womenCellMembers">
                      <td>{{ member.sno }}</td>
                      <td>{{ member.name }}</td>
                      <td>{{ member.designation }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="section-head" style="margin-top: 26px;">
                <h3>About Women Empowerment Cell</h3>
                <p>
                  Supportive initiatives for awareness, safety, counselling, empowerment, and leadership development.
                </p>
              </div>

              <div class="section-copy">
                <p *ngFor="let paragraph of womenIntro">
                  {{ paragraph }}
                </p>
              </div>

              <div class="numbered-list">
                <article class="number-card" *ngFor="let item of womenPoints; let i = index">
                  <div class="number-badge">{{ i + 1 }}</div>
                  <div>
                    <p><strong>{{ item.title }}</strong></p>
                    <p>{{ item.description }}</p>
                  </div>
                </article>
              </div>

              <div class="section-copy" style="margin-top: 18px;">
                <p>{{ womenClosing }}</p>
              </div>
            </section>
          </ng-container>
        </ng-container>
      </main>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Institutional Support</span>
        <h3>Student Safety &amp; Empowerment</h3>
        <p>
          FMCET promotes a safe, inclusive, and supportive academic environment
          through its dedicated Women Empowerment Cell.
        </p>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Academic Environment</span>
        <h3>Support, Guide, Empower</h3>
        <p>
          The Women Empowerment Cell helps students grow through awareness,
          counselling, mentorship, leadership development, and institutional support.
        </p>
      </article>
    </section>
  </div>
</div>